import React from 'react';
import PropTypes from 'prop-types';

import {classes, styles} from '../index';

const SlideContainer = ({children, className, containerStyle, ...rest}) => {
    if (rest.duration && rest.duration % 1000 !== 0) {
        rest.duration *= 1000;
    }
    return (
        <div>
            <div className={classes.slideDuration(rest)} style={styles.slideDuration(rest)}/>
            <div className={classes.slideContainer(rest, className)} style={containerStyle}>
                {children}
            </div>
        </div>
    );
};

SlideContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    className: PropTypes.string.isRequired,
    containerStyle: PropTypes.object
};

SlideContainer.defaultProps = {
    active: false
};

export default SlideContainer;


// WEBPACK FOOTER //
// ./src/components/common/slideshow/SlideContainer.js